import styled from 'styled-components';
import Button from 'shared/ui/Button';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
Wrapper.displayName = 'Wrapper';

export const Image = styled.img`
  max-width: 573px;
  width: 100%;
`;
Image.displayName = 'Image';

export const Label = styled.div`
  font-size: 15px;
  color: ${colors.blueGrey};
  padding-bottom: 21px;
  padding-top: 13px;
`;
Label.displayName = 'Label';

export const ButtonLink = styled(Button).attrs({ variant: 'link' })``;
ButtonLink.displayName = 'ButtonLink';
